import { SuburbanAreaContainer } from '../../containers/filters/SuburbanAreaContainer';
import { EFilterType, IOpenableFilter } from '../../types/filters';

export const suburbanArea: IOpenableFilter = {
  component: SuburbanAreaContainer,
  type: EFilterType.Openable,
};
